<template>
  <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
    <div class="form-success tw-text-center tw-ml-auto tw-w-full tw-py-5">
      Obrigado pelo seu registo
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';


</style>
